import axios from 'axios'
import store from '@/store'

const url = process.env.VUE_APP_URL_API
const instance = axios.create({
  baseURL: url
})

const accessToken = localStorage.getItem('accessToken')
if (accessToken) {
  instance.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken
}
instance.defaults.headers.post['Content-Type'] = 'application/json'

instance.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (parseInt(error.response.status) === 401) {
    store.dispatch('auth/logout')
  }
  return Promise.reject(error)
})

export default instance